<template>
	<div class="blm-number-input">
		<span class="number-control increase" :class="{'invalid': invalid}" @click="next">+</span>
		<span class="number"><slot name="value" :value="value">{{value}}</slot></span>
		<span class="number-control decrease" :class="{'invalid': invalid}" @click="previous">-</span>
	</div>
</template>

<script>
export default {
	props: {
		value: { type: Number, default: 0 },
		steps: { type: Number, default: 1 },
		max: { type: Number },
		min: { type: Number, default: 0 },
		negative: { type: [Boolean, String], default: false },
		invalid: { type: Boolean, default: false }
	},
	methods: {
		next() {
			let next = this.inRange(this.value + this.steps);
			this.$emit('input', next);
		},
		previous() {
			let previous = this.inRange(this.value - this.steps);
			this.$emit('input', previous);
		},
		inRange(value) {
			let minFixed = this.max ? Math.min(this.max, value) : value;
			let maxMinFixed = Math.max(this.min, minFixed);
			let allowNegative = this.negative || this.negative === '';
			let negativeFixed = allowNegative ? maxMinFixed : Math.max(0, maxMinFixed);
			return maxMinFixed;
		},
	}
}
</script>

<style lang="scss" scoped>
.blm-number-input {
	width: fit-content;
	display: flex;
	justify-content: space-between;
}

.number {
	display: flex;
	align-items: center;
	margin: 0 5px;
	width: fit-content;
	text-align: center;
}

.number-control {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	width: 20px;
	height: 20px;
	border: 1px solid rgb(52, 64, 133);
	cursor: pointer;
	background: white;
	user-select: none;
	font-weight: bold;
}

.invalid {
	border-color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/BlmNumberInput.vue